import { render } from "./inbound-form.vue?vue&type=template&id=21cd6a0e&scoped=true"
import script from "./inbound-form.vue?vue&type=script&lang=js"
export * from "./inbound-form.vue?vue&type=script&lang=js"

import "./inbound-form.vue?vue&type=style&index=0&id=21cd6a0e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cd6a0e"]])

export default __exports__